import React from 'react';

import { t } from 'i18next';
import { Trans } from 'react-i18next';

import { Box } from '@mui/material';

import { Typography } from '@datanomik/commons-ui';

import { DatanomikIsoWhite } from '@/views/common/Logo';

const ContentBox = () => {
  const year = (new Date()).getFullYear();

  return (
    <Box className="dn-text-datanomik">
      <DatanomikIsoWhite className="dn-logo-white-small" />
      <Box>
        <Typography variant="h3" color="neutral.0">
          <Trans i18nKey="Welcome back to Business Gate">
            Welcome back to
            {' '}
            <strong>Business Gate</strong>
          </Trans>
        </Typography>
        <Typography color="neutral.0">
          <Trans i18nKey="Understand your company's cash flow and make strategic decisions with Datanomik's Smart Treasury">
            Understand your company&apos;s cash flow and make strategic decisions with
            {' '}
            <strong>Datanomik&apos;s</strong>
            {' '}
            <span>Smart treasury</span>
          </Trans>
        </Typography>
      </Box>
      <Typography className="dn-legal" variant="body2">{t('© {{year}} Datanomik. All rights reserved.', { year })}</Typography>
    </Box>
  );
};

export default ContentBox;
